import {Component, Input, EventEmitter, Output} from '@angular/core';
import {User, IUserAlias} from "../../services/User";
import {Observable} from "rxjs";
import {Notify} from "../../services/Notify";
import {IJobType} from "../../interfaces/IJobType";
import {JobTypes} from "../../services/JobTypes";

const NAME_REGEX = /^[a-zA-Z\s\-]+$/;

@Component({
  selector: 'user-aliases-list',
  templateUrl: 'aliases.html'
})
export class UserAliasesListCmp {
  @Input() userID:number;
  @Output() update = new EventEmitter();
  public aliases:IUserAlias[] = [];
  public loading = false;
  public jobTypesList:IJobType[] = [];
  public aliasErrors:{[index: number]: {[field: string]: string}} = {};

  constructor(private usrSrv:User, private jobTypes:JobTypes) {
    this.jobTypes.loadToList(this.jobTypesList);
  }

  ngOnChanges() {
    if (this.userID && (!this.aliases || this.aliases.length < 1)) {
      this.load();
    }
  }

  newAlias() {
    if (this.aliases.length > 0) {
      return;
    }
    this.aliases.push({user_id: this.userID});
  }

  load() {
    if (this.loading) {
      return;
    }
    this.loading = true;
    this.usrSrv.getAliases(this.userID).subscribe((aliases)=> {
      this.loading = false;
      if (aliases && aliases.length > 0) {
        this.aliases = aliases;
      } else {
        this.aliases = [];
      }
      this.aliasErrors = {};
    }, ()=> {
      this.loading = false;
    });
  }

  private validateAlias(a:IUserAlias, index:number):boolean {
    this.aliasErrors[index] = {};

    let fname = (a.fname || '').trim();
    if (!fname) {
      this.aliasErrors[index]['fname'] = 'Field is required';
    } else if (fname.length > 120 || !NAME_REGEX.test(fname)) {
      this.aliasErrors[index]['fname'] = 'First Name can contain up to 120 letters, spaces or hyphen';
    }

    let lname = (a.lname || '').trim();
    if (!lname) {
      this.aliasErrors[index]['lname'] = 'Field is required';
    } else if (lname.length > 120 || !NAME_REGEX.test(lname)) {
      this.aliasErrors[index]['lname'] = 'Last Name can contain up to 120 letters, spaces or hyphen';
    }

    let title = (a.title || '').trim();
    if (title && title.length > 60) {
      this.aliasErrors[index]['title'] = 'Title can contain up to 60 symbols';
    }

    if (a.job_type_id && this.jobTypesList.length > 0) {
      let valid = this.jobTypesList.some(jt => jt.id == a.job_type_id);
      if (!valid) {
        this.aliasErrors[index]['job_type_id'] = 'Not valid value for JobType';
      }
    }

    return Object.keys(this.aliasErrors[index]).length === 0;
  }

  save(a:IUserAlias) {
    if (!a) {
      return;
    }
    if (a.id) {
      this.updateAlias(a);
    } else {
      this.createAlias(a);
    }
  }

  createAlias(a:IUserAlias) {
    let n = new Notify();
    let idx = this.aliases.indexOf(a);
    if (!this.validateAlias(a, idx)) {
      let errors = this.aliasErrors[idx];
      let firstError = errors[Object.keys(errors)[0]];
      n.warning(firstError);
      return;
    }
    a.___updating = true;
    this.usrSrv.createAlias(a).subscribe(()=> {
      n.created();
      a.___updating = true;
      this.load();
      this.update.emit();
    }, (err)=> {
      a.___updating = true;
      n.httpErr(err);
    });
  }

  updateAlias(a:IUserAlias) {
    let n = new Notify();
    let idx = this.aliases.indexOf(a);
    if (!this.validateAlias(a, idx)) {
      let errors = this.aliasErrors[idx];
      let firstError = errors[Object.keys(errors)[0]];
      n.warning(firstError);
      return;
    }
    a.___updating = true;
    this.usrSrv.updateAlias(a).subscribe(()=> {
      n.updated();
      a.___updating = true;
      this.load();
      this.update.emit();
    }, (err)=> {
      a.___updating = true;
      n.httpErr(err);
    });
  }

  remove(a:IUserAlias) {
    if (!a.id) {
      let i = this.aliases.indexOf(a);
      if (i > -1) {
        this.aliases.splice(i, 1);
        delete this.aliasErrors[i];
      }
    } else {
      if (a.___removing) {
        return;
      }
      a.___removing = true;
      this.usrSrv.removeAlias(a.id).subscribe(()=> {
        a.___removing = false;
        let i = this.aliases.indexOf(a);
        if (i > -1) {
          this.aliases.splice(i, 1);
          delete this.aliasErrors[i];
        } else {
          this.load();
        }
        this.update.emit();
      }, (err)=> {
        a.___removing = false;
        let n = new Notify();
        n.httpErr(err);
      });
    }
  }

  apply(alias:IUserAlias) {
    if (alias.___updating || !alias.id) {
      return;
    }
    alias.___updating = true;
    this.usrSrv.setAliasAsMain(alias.id).subscribe(()=> {
      alias.___updating = false;
      this.update.emit();
      this.load();
    }, (err)=> {
      alias.___updating = false;
      let n = new Notify();
      n.httpErr(err);
    });
  }
}
